export const softGreen = '#b8e986'
